import { render, staticRenderFns } from "./DoctorClinicSettings.vue?vue&type=template&id=07ff7808&"
import script from "./DoctorClinicSettings.vue?vue&type=script&lang=js&"
export * from "./DoctorClinicSettings.vue?vue&type=script&lang=js&"
import style0 from "./DoctorClinicSettings.vue?vue&type=style&index=0&id=07ff7808&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports